(() => {
const activeVariant = document.documentElement.getAttribute("data-home-experiment-variant");
const activePage = document.querySelector(`[data-home-experiment-variant-page="${activeVariant}"]`);
const productGroups = activePage ? activePage.querySelectorAll("[data-product-group]") : document.querySelectorAll("[data-product-group]");
const productMenus = activePage ? activePage.querySelectorAll(".a-product-menu") : document.querySelectorAll(".a-product-menu");

productMenus.forEach((menu) => {
  menu.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    menu.removeAttribute("open");
    menu.querySelector("summary")?.focus();
  });
});

document.addEventListener("pointerdown", (event) => {
  productMenus.forEach((menu) => {
    if (menu.open && !menu.contains(event.target)) menu.removeAttribute("open");
  });
});

productGroups.forEach((group) => {
  const tabs = Array.from(group.querySelectorAll("[data-product-tab]"));
  const panels = Array.from(group.querySelectorAll("[data-product-panel]"));

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const selectedProduct = tab.dataset.productTab;

      tabs.forEach((candidate) => {
        const isSelected = candidate === tab;
        candidate.setAttribute("aria-selected", String(isSelected));
        candidate.tabIndex = isSelected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.productPanel !== selectedProduct;
      });
    });
  });
});

const revealItems = activePage ? activePage.querySelectorAll(".reveal") : document.querySelectorAll(".reveal");

if ("IntersectionObserver" in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  revealItems.forEach((item) => observer.observe(item));
} else {
  revealItems.forEach((item) => item.classList.add("is-visible"));
}
})();
